import React from 'react';
import variables from '../../styles/variables.module.scss';
import Highlight from '../../components/Highlight';

import img1Alt from '../../assets/frames/medograf-extraimg1@2x-min.png';
import img2Alt from '../../assets/frames/medograf-extraimg2@2x-min.png';
import img3Alt from '../../assets/frames/medograf-extraimg3@2x-min.png';

import env1 from '../../assets/envImages/medograf-env1.jpg';
import env2 from '../../assets/envImages/medograf-env2.jpg';
import hero from '../../assets/hero/medograf-hero@2x-min.png';
import footerBanner from '../../assets/envImages/medograf-footerBanner.jpg';

export default {
  path: '/cases/medograf',
  color: variables.medograf,
  hero: { fall: hero },
  xtra: [
    { fall: img1Alt },
    { fall: img2Alt },
    { fall: img3Alt },
  ],
  footerBanner: { fall: footerBanner },
  environments: { env1, env2 },
  // quoteData: {
  //   quote: '.',
  //   name: 'Fabian Grapengiesser',
  //   profession: 'CEO, Medograf',
  // },
  title: 'Medograf',
  sideHeadingFirst: 'iOS application',
  sideHeadingSecond: 'Developed in Swift with Texture',
  infoTitle: 'What we built',
  infoBody:
  <span>
We App helped Medograf build a mobile version of their service. The app includes several features, such as networking features, group/community creation, access to information and advice from healthcare professionals, and more.
    <br />
    <br />
The mobile app was built fully in
    {' '}
    <Highlight>Swift for iOS</Highlight>
.
  </span>,
  infoData: {
    Scope: ['Scope', 'Project management', 'User experience', 'UI & UX design'],
    Deliverables: ['Deliverables', 'iOS development', 'Android development', 'Cross-platform', 'Software development'],
    Goal: ['Goal', 'Project management', 'User experience', 'UI & UX design', 'Maintanance/support'],
  },
  titleBodyData: {
    0: {
      title: 'Sharing the knowledge and experience of living with a mental disorder',
      body: 'Medograf is a platform and a network for people living with mental disorder to share and receive support. Completely anonymously.',
    },
  },
};
